export default {
    text: {
        title: 'Texto',
        addText: 'Nuevo texto',
        fontFamily: 'Familia de fuentes',
        fontSize: 'Font size',
        textAlignment: 'Alineación de texto',
        fontColor: 'Color de fuente',
        lineSpacing: 'Interlineado',
        arialSerif: 'Arial (sin remates)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sin serifa)',
        trebuchetMSSansSerif: 'Trebuchet MS (sin remates)',
        timesNewRomanSerif: 'Times New Roman (serif)',
        georgiaSerif: 'Georgia (cursiva)',
        garamondSerif: 'Garamond (con serifa)',
        courierNewMonospace: 'Mensajero nuevo (monoespaciado)',
        brushScriptMTCursive: 'Brocha Script MT (cursiva)',
        backgroundColor: 'Color de fondo',
    },
};
